import styled from "styled-components";
import Message from "./Message";
import { useTranslation } from "../../../hooks";
import { transformLines } from "../../../utils";

const Row: React.FC<{ cells: number[]; colors: string[] }> = ({
  cells,
  colors,
}) => {
  return (
    <div className="row">
      {cells.map((cell: number, i: number) => {
        const backgroundColor = colors[cell];
        const className = cell ? "cell line" : "cell";
        return (
          <div key={i} className={className} style={{ backgroundColor }}></div>
        );
      })}
    </div>
  );
};

// the right margin is the same length as the index/win line number/ width, so the squares looks centered
const StyledWinLines = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 40em;
  margin-right: 1em;

  .grid {
    display: flex;
    flex-direction: row;
    padding: 0.5em;

    .index {
      font-size: 0.7em;
      width: 1em;
      align-self: flex-end;
      padding-right: 0.3em;
      text-align: right;
    }

    .content {
      display: flex;
      flex-direction: column;
      .row {
        display: flex;
        .cell {
          width: 1em;
          height: 1em;
          margin: 0.1em;
        }
      }
    }
  }

  ${(props: any) => props.customStyle || ""}
` as any;

type WinLinesType = {
  data: number[][] | number[][][];
  colors: string[];
  message: any;
  style?: any;
};

const WinLines: React.FC<WinLinesType> = ({ data, colors, message, style }) => {
  // data can be of type [..., [2, 1, 1, 2], ...] or [..., [[0, 0, 0, 0],[0, 1, 1, 0], [1, 0, 0, 1]], ...]
  // so the parseWinData function is to handle both cases
  const _data = transformLines(data);

  const content = _data.map((grid: number[][], i: number) => {
    return (
      <div key={i} className="grid">
        <div className="index">{i + 1}</div>
        <div className="content">
          {grid.map((row, i) => (
            <Row key={i} cells={row} colors={colors} />
          ))}
        </div>
      </div>
    );
  });

  return (
    <StyledWinLines customStyle={style}>
      {content}
      <Message text={useTranslation(message.text)} image={message.image} />
    </StyledWinLines>
  );
};

export default WinLines;
